<script setup lang="ts">
defineProps<{
  block?: Record<string, any>;
}>();
</script>

<template>
  <a
    v-if="block?.content.target === 'true'"
    :href="block?.content.link"
    target="_blank"
    class="btn from-left block-button"
  >
    {{ block?.content.text }}
  </a>
  <a
    v-else
    :href="block?.content.link"
    :target="block?.content.target"
    class="btn from-left block-button"
  >
    {{ block?.content.text }}
  </a>
</template>
